<template>
  <div>
    <v-list-item
      id="list_item1"
      v-for="item in courses"
      :key="item.title"
      link
      :class="{ active: item.isActive }"
    >
      <v-list-item-content @click="getLesson(item.id)">
        <v-list-item-title>
          <div v-if="item.hasMessages" class="circle"></div>
          {{ item.name }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider />
    <!-- <v-list-item id="list_item2">
      <v-list-item-content v-if="isTeacherApp" @click="toJournal">
        <v-list-item-title>������</v-list-item-title>
      </v-list-item-content>
    </v-list-item>-->
    <v-list-item v-if="smallScreen" id="list_item3" link class="menuItems">
      <v-list-item-content @click="toCalendar">
        <v-list-item-title class="menuIcon">
          <v-icon medium color="primary" class="iconStyle"
            >calendar_today</v-icon
          >
          Календар</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="smallScreen" id="list_item4" link class="menuItems">
      <v-list-item-content @click="toLibrary">
        <v-list-item-title class="menuIcon">
          <v-icon medium color="primary" class="iconStyle">menu_book</v-icon>
          Бібліотека</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
    <v-list-item id="list_item4" link class="menuItems">
      <v-list-item-content @click="toReportCard">
        <v-list-item-title class="menuIcon">
          <v-icon medium color="primary" class="iconStyle">today</v-icon>
          Табель</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import statesEnum from '@/enums/statesEnum';

export default {
  name: 'CourseItem',
  props: {
    smallScreen: Boolean,
  },
  computed: {
    coursesList() {
      return this.$store.getters['CourseItemsStore/getCourses'];
    },
    courses() {
      const courseId = this.$store.getters['LessonsStore/getCurrentCourseId'];
      return this.coursesList.map((item) => {
        item.setIsActive(item.id === courseId);
        return item;
      });
    },
  },
  created() {
    this.getCourses();
  },

  methods: {
    async getCourses() {
      const payload = {
        token: this.token,
      };
      await this.$store.dispatch('CourseItemsStore/getItems', payload);
    },
    getLesson(courseId) {
      this.$emit('courseItemsEvent', {
        type: 'getLesson',
        data: {
          courseId,
        },
      });
      this.$router.push({
        name: statesEnum.CLASS,
        query: { courseId: courseId },
      });
    },
    toReportCard() {
      this.$router.push({ name: statesEnum.REPORT_CARD });
    },
    toLibrary() {
      this.$router.push({ name: statesEnum.LIBRARY });
    },
    toCalendar() {
      this.$router.push({ name: statesEnum.CALENDAR });
    },
    toJournal() {
      this.$router.push({ name: statesEnum.JOURNAL });
    },
    logout() {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('rawUser');
      this.$store.dispatch('ConfigStore/removeDemoToken');

      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<style lang="less" scoped>
.circle {
  position: absolute;
  right: 30px;
  top: 17px;
  background: red;
  width: 10px;
  height: 10px;
  border-radius: 50px 50px 50px 50px;
}

.active {
  background: white;
  border-left-color: #f15a22; /* Цвет линии слева */
  border-left-style: solid; /* Стиль линии */
  border-left-width: 4px; /* Толщина линии */
}
</style>
